import React, { JSX } from 'react';

type DefaultDayContentsProps = {
  day: number;
  date?: Date;
};

const DefaultDayContents = (props: Readonly<DefaultDayContentsProps>): JSX.Element => {
  const { day } = props;
  return (
    <div className="day-contents" data-day={day}>
      {day}
    </div>
  );
};

export default DefaultDayContents;
